let wasm;

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint32ArrayMemory0 = null;
function getUint32ArrayMemory0() {
    if (cachedUint32ArrayMemory0 === null || cachedUint32ArrayMemory0.byteLength === 0) {
        cachedUint32ArrayMemory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32ArrayMemory0;
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getUint32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    }
}

let WASM_VECTOR_LEN = 0;

const __wbindgen_enum_EditFunctionName = ["clear", "offset", "copy", "paste", "flip_h", "flip_v"];

const CameraFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_camera_free(ptr >>> 0, 1));

const CanvasFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_canvas_free(ptr >>> 0, 1));

const DataPointerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_datapointer_free(ptr >>> 0, 1));

const FileHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_filehandle_free(ptr >>> 0, 1));

const InterfaceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_interface_free(ptr >>> 0, 1));

const PreviewCanvasFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_previewcanvas_free(ptr >>> 0, 1));

const SerializerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_serializer_free(ptr >>> 0, 1));

const Vec2Finalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vec2_free(ptr >>> 0, 1));

/**
 * Camera for viewing the canvas
 *
 * The camera defines the position and zoom level for rendering the canvas.
 */
export class Camera {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Camera.prototype);
        obj.__wbg_ptr = ptr;
        CameraFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CameraFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_camera_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get x() {
        const ret = wasm.__wbg_get_camera_x(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set x(arg0) {
        wasm.__wbg_set_camera_x(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get y() {
        const ret = wasm.__wbg_get_camera_y(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set y(arg0) {
        wasm.__wbg_set_camera_y(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get zoom() {
        const ret = wasm.__wbg_get_camera_zoom(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} arg0
     */
    set zoom(arg0) {
        wasm.__wbg_set_camera_zoom(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) Camera.prototype[Symbol.dispose] = Camera.prototype.free;

/**
 * Canvas for rendering pixel art
 *
 * The canvas is responsible for rendering pixel art files, overlays, selections,
 * and other UI elements.
 */
export class Canvas {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Canvas.prototype);
        obj.__wbg_ptr = ptr;
        CanvasFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CanvasFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_canvas_free(ptr, 0);
    }
    /**
     * Draw file from [`Interface`] to canvas.
     *
     * # Panics
     *
     * Panics if no file is active in the `Interface`.
     * @param {Interface} int
     */
    render(int) {
        _assertClass(int, Interface);
        wasm.canvas_render(this.__wbg_ptr, int.__wbg_ptr);
    }
    /**
     * @param {number} x
     * @param {number} y
     */
    on_pointer_move(x, y) {
        wasm.canvas_on_pointer_move(this.__wbg_ptr, x, y);
    }
    /**
     * @returns {number}
     */
    get width() {
        const ret = wasm.__wbg_get_canvas_width(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} arg0
     */
    set width(arg0) {
        wasm.__wbg_set_canvas_width(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get height() {
        const ret = wasm.__wbg_get_canvas_height(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} arg0
     */
    set height(arg0) {
        wasm.__wbg_set_canvas_height(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {Camera}
     */
    get camera() {
        const ret = wasm.__wbg_get_canvas_camera(this.__wbg_ptr);
        return Camera.__wrap(ret);
    }
    /**
     * @param {Camera} arg0
     */
    set camera(arg0) {
        _assertClass(arg0, Camera);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_canvas_camera(this.__wbg_ptr, ptr0);
    }
    /**
     * @returns {number}
     */
    get overlay_width() {
        const ret = wasm.__wbg_get_canvas_overlay_width(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} arg0
     */
    set overlay_width(arg0) {
        wasm.__wbg_set_canvas_overlay_width(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get grid_zoom_visible() {
        const ret = wasm.__wbg_get_canvas_grid_zoom_visible(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} arg0
     */
    set grid_zoom_visible(arg0) {
        wasm.__wbg_set_canvas_grid_zoom_visible(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {boolean}
     */
    get show_symmetry_guide() {
        const ret = wasm.__wbg_get_canvas_show_symmetry_guide(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {boolean} arg0
     */
    set show_symmetry_guide(arg0) {
        wasm.__wbg_set_canvas_show_symmetry_guide(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {boolean}
     */
    get tiling_preview() {
        const ret = wasm.__wbg_get_canvas_tiling_preview(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {boolean} arg0
     */
    set tiling_preview(arg0) {
        wasm.__wbg_set_canvas_tiling_preview(this.__wbg_ptr, arg0);
    }
    /**
     * Set the camera position and zoom level
     * @param {number} x
     * @param {number} y
     * @param {number} zoom
     */
    set_camera(x, y, zoom) {
        wasm.canvas_set_camera(this.__wbg_ptr, x, y, zoom);
    }
    /**
     * Convert a position on the canvas to a position in the file
     * @param {number} x
     * @param {number} y
     * @returns {Vec2}
     */
    canvas_pos_to_file_pixel(x, y) {
        const ret = wasm.canvas_canvas_pos_to_file_pixel(this.__wbg_ptr, x, y);
        return Vec2.__wrap(ret);
    }
    /**
     * @param {number} x
     * @param {number} y
     * @returns {Vec2}
     */
    canvas_pos_to_file_center2(x, y) {
        const ret = wasm.canvas_canvas_pos_to_file_center2(this.__wbg_ptr, x, y);
        return Vec2.__wrap(ret);
    }
    /**
     * Create a new canvas with the specified dimensions
     * @param {number} width
     * @param {number} height
     * @returns {Canvas}
     */
    static new(width, height) {
        const ret = wasm.canvas_new(width, height);
        return Canvas.__wrap(ret);
    }
    /**
     * Get the size of the canvas in pixels
     * @returns {number}
     */
    size() {
        const ret = wasm.canvas_size(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * Resize the canvas to the specified dimensions
     * @param {number} width
     * @param {number} height
     */
    resize(width, height) {
        wasm.canvas_resize(this.__wbg_ptr, width, height);
    }
    /**
     * Get a pointer to the canvas data
     * @returns {number}
     */
    data_ptr() {
        const ret = wasm.canvas_data_ptr(this.__wbg_ptr);
        return ret >>> 0;
    }
}
if (Symbol.dispose) Canvas.prototype[Symbol.dispose] = Canvas.prototype.free;

export class DataPointer {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DataPointerFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_datapointer_free(ptr, 0);
    }
}
if (Symbol.dispose) DataPointer.prototype[Symbol.dispose] = DataPointer.prototype.free;

export class FileHandle {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FileHandle.prototype);
        obj.__wbg_ptr = ptr;
        FileHandleFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FileHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_filehandle_free(ptr, 0);
    }
    /**
     * @param {number} width
     * @param {number} height
     * @param {Uint32Array} data
     * @param {string} layer_name
     * @returns {FileHandle}
     */
    static new_from_data(width, height, data, layer_name) {
        const ptr0 = passArray32ToWasm0(data, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(layer_name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.filehandle_new_from_data(width, height, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return FileHandle.__wrap(ret[0]);
    }
    /**
     * @param {number} width
     * @param {number} height
     * @returns {FileHandle}
     */
    static new(width, height) {
        const ret = wasm.filehandle_new(width, height);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return FileHandle.__wrap(ret[0]);
    }
    /**
     * @returns {number}
     */
    get width() {
        const ret = wasm.filehandle_width(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    get height() {
        const ret = wasm.filehandle_height(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} id
     */
    set_id(id) {
        wasm.filehandle_set_id(this.__wbg_ptr, id);
    }
    /**
     * @param {number} frame
     * @param {number} layer
     * @param {number} x
     * @param {number} y
     * @returns {number}
     */
    get_pixel(frame, layer, x, y) {
        const ret = wasm.filehandle_get_pixel(this.__wbg_ptr, frame, layer, x, y);
        return ret >>> 0;
    }
    /**
     * @param {number} frame
     * @returns {number}
     */
    render_ptr(frame) {
        const ret = wasm.filehandle_render_ptr(this.__wbg_ptr, frame);
        return ret >>> 0;
    }
    /**
     * @returns {any[]}
     */
    get_frame_info() {
        const ret = wasm.filehandle_get_frame_info(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {number} frame
     * @returns {any[]}
     */
    get_layer_info(frame) {
        const ret = wasm.filehandle_get_layer_info(this.__wbg_ptr, frame);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string[]}
     */
    get_history_past() {
        const ret = wasm.filehandle_get_history_past(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {string[]}
     */
    get_history_future() {
        const ret = wasm.filehandle_get_history_future(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) FileHandle.prototype[Symbol.dispose] = FileHandle.prototype.free;

export class Interface {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Interface.prototype);
        obj.__wbg_ptr = ptr;
        InterfaceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InterfaceFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_interface_free(ptr, 0);
    }
    select_all() {
        const ret = wasm.interface_select_all(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} layer
     */
    set_active(frame, layer) {
        const ret = wasm.interface_set_active(this.__wbg_ptr, frame, layer);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {boolean} enabled
     */
    set_wrap_edits(enabled) {
        const ret = wasm.interface_set_wrap_edits(this.__wbg_ptr, enabled);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    clear_selection() {
        const ret = wasm.interface_clear_selection(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {FileHandle} handle
     * @param {number} frame
     * @param {number} layer
     */
    set_active_file(handle, frame, layer) {
        _assertClass(handle, FileHandle);
        wasm.interface_set_active_file(this.__wbg_ptr, handle.__wbg_ptr, frame, layer);
    }
    invert_selection() {
        const ret = wasm.interface_invert_selection(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    clear_active_file() {
        wasm.interface_clear_active_file(this.__wbg_ptr);
    }
    /**
     * @param {number} x
     * @param {number} y
     */
    set_symmetry_center(x, y) {
        const ret = wasm.interface_set_symmetry_center(this.__wbg_ptr, x, y);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} x2
     * @param {number} y2
     */
    set_symmetry_center2(x2, y2) {
        const ret = wasm.interface_set_symmetry_center2(this.__wbg_ptr, x2, y2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {EditFunctionName} name
     * @param {any} options
     */
    execute_edit_function(name, options) {
        const ret = wasm.interface_execute_edit_function(this.__wbg_ptr, (__wbindgen_enum_EditFunctionName.indexOf(name) + 1 || 7) - 1, options);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {any}
     */
    get_symmetry_settings() {
        const ret = wasm.interface_get_symmetry_settings(this.__wbg_ptr);
        return ret;
    }
    reset_symmetry_center() {
        const ret = wasm.interface_reset_symmetry_center(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {any} settings
     */
    set_symmetry_settings(settings) {
        const ret = wasm.interface_set_symmetry_settings(this.__wbg_ptr, settings);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {EditFunctionName} name
     * @returns {any}
     */
    get_default_edit_function_options(name) {
        const ret = wasm.interface_get_default_edit_function_options(this.__wbg_ptr, (__wbindgen_enum_EditFunctionName.indexOf(name) + 1 || 7) - 1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {Interface}
     */
    static new() {
        const ret = wasm.interface_new();
        return Interface.__wrap(ret);
    }
    /**
     * @param {number} from
     * @param {number} to
     */
    move_frame(from, to) {
        const ret = wasm.interface_move_frame(this.__wbg_ptr, from, to);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} width
     * @param {number} height
     */
    resize_file(width, height) {
        const ret = wasm.interface_resize_file(this.__wbg_ptr, width, height);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame_index
     */
    remove_frame(frame_index) {
        const ret = wasm.interface_remove_frame(this.__wbg_ptr, frame_index);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame_index
     */
    duplicate_frame(frame_index) {
        const ret = wasm.interface_duplicate_frame(this.__wbg_ptr, frame_index);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} layer
     */
    add_layer_to_frame(frame, layer) {
        const ret = wasm.interface_add_layer_to_frame(this.__wbg_ptr, frame, layer);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} duration
     */
    set_frame_duration(frame, duration) {
        const ret = wasm.interface_set_frame_duration(this.__wbg_ptr, frame, duration);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} from
     * @param {number} to
     */
    move_layer_in_frame(frame, from, to) {
        const ret = wasm.interface_move_layer_in_frame(this.__wbg_ptr, frame, from, to);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} from
     */
    merge_layers_in_frame(frame, from) {
        const ret = wasm.interface_merge_layers_in_frame(this.__wbg_ptr, frame, from);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} layer
     * @param {string} name
     */
    rename_layer_in_frame(frame, layer, name) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.interface_rename_layer_in_frame(this.__wbg_ptr, frame, layer, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} layer
     */
    remove_layer_from_frame(frame, layer) {
        const ret = wasm.interface_remove_layer_from_frame(this.__wbg_ptr, frame, layer);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} duration
     */
    set_all_frames_duration(duration) {
        const ret = wasm.interface_set_all_frames_duration(this.__wbg_ptr, duration);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} layer
     */
    duplicate_layer_in_frame(frame, layer) {
        const ret = wasm.interface_duplicate_layer_in_frame(this.__wbg_ptr, frame, layer);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame
     * @param {number} layer
     * @param {boolean} visible
     */
    set_layer_visible_in_frame(frame, layer, visible) {
        const ret = wasm.interface_set_layer_visible_in_frame(this.__wbg_ptr, frame, layer, visible);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    redo() {
        const ret = wasm.interface_redo(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    undo() {
        const ret = wasm.interface_undo(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} frame_index
     */
    add_frame(frame_index) {
        const ret = wasm.interface_add_frame(this.__wbg_ptr, frame_index);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {FileHandle}
     */
    deserialize() {
        const ret = wasm.interface_deserialize(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return FileHandle.__wrap(ret[0]);
    }
    /**
     * @param {number} bytes
     * @returns {any}
     */
    deserialize_ptr(bytes) {
        const ret = wasm.interface_deserialize_ptr(this.__wbg_ptr, bytes);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {FileHandle} handle
     * @returns {any}
     */
    serialize(handle) {
        _assertClass(handle, FileHandle);
        const ret = wasm.interface_serialize(this.__wbg_ptr, handle.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} key
     * @returns {boolean}
     */
    on_key_down(key) {
        const ptr0 = passStringToWasm0(key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.interface_on_key_down(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} modifiers
     */
    on_pointer_up(x, y, modifiers) {
        const ret = wasm.interface_on_pointer_up(this.__wbg_ptr, x, y, modifiers);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {number}
     */
    get_active_tool() {
        const ret = wasm.interface_get_active_tool(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} modifiers
     */
    on_pointer_down(x, y, modifiers) {
        const ret = wasm.interface_on_pointer_down(this.__wbg_ptr, x, y, modifiers);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} modifiers
     */
    on_pointer_move(x, y, modifiers) {
        const ret = wasm.interface_on_pointer_move(this.__wbg_ptr, x, y, modifiers);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} tool_id
     */
    set_active_tool(tool_id) {
        const ret = wasm.interface_set_active_tool(this.__wbg_ptr, tool_id);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {number}
     */
    get_active_color() {
        const ret = wasm.interface_get_active_color(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} modifiers
     */
    on_pointer_hover(x, y, modifiers) {
        const ret = wasm.interface_on_pointer_hover(this.__wbg_ptr, x, y, modifiers);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} color
     */
    set_active_color(color) {
        wasm.interface_set_active_color(this.__wbg_ptr, color);
    }
    /**
     * @param {number} x
     * @param {number} y
     * @returns {boolean}
     */
    is_pixel_selected(x, y) {
        const ret = wasm.interface_is_pixel_selected(this.__wbg_ptr, x, y);
        return ret !== 0;
    }
    on_pointer_cancel() {
        const ret = wasm.interface_on_pointer_cancel(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {any}
     */
    get_active_options() {
        const ret = wasm.interface_get_active_options(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {any} options
     */
    set_active_options(options) {
        const ret = wasm.interface_set_active_options(this.__wbg_ptr, options);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {boolean}
     */
    get_is_current_tool_active() {
        const ret = wasm.interface_get_is_current_tool_active(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string[]}
     */
    get_tools() {
        const ret = wasm.interface_get_tools(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
}
if (Symbol.dispose) Interface.prototype[Symbol.dispose] = Interface.prototype.free;

export class PreviewCanvas {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PreviewCanvas.prototype);
        obj.__wbg_ptr = ptr;
        PreviewCanvasFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PreviewCanvasFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_previewcanvas_free(ptr, 0);
    }
    /**
     * @param {FileHandle} handle
     * @param {number} frame
     */
    draw_file_frame(handle, frame) {
        _assertClass(handle, FileHandle);
        const ret = wasm.previewcanvas_draw_file_frame(this.__wbg_ptr, handle.__wbg_ptr, frame);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {FileHandle} handle
     * @param {number} frame
     * @param {number} layer
     */
    draw_file_layer(handle, frame, layer) {
        _assertClass(handle, FileHandle);
        const ret = wasm.previewcanvas_draw_file_layer(this.__wbg_ptr, handle.__wbg_ptr, frame, layer);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} width
     * @param {number} height
     * @returns {PreviewCanvas}
     */
    static new(width, height) {
        const ret = wasm.previewcanvas_new(width, height);
        return PreviewCanvas.__wrap(ret);
    }
    /**
     * @returns {number}
     */
    get data_ptr() {
        const ret = wasm.previewcanvas_data_ptr(this.__wbg_ptr);
        return ret >>> 0;
    }
}
if (Symbol.dispose) PreviewCanvas.prototype[Symbol.dispose] = PreviewCanvas.prototype.free;

export class Serializer {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SerializerFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_serializer_free(ptr, 0);
    }
}
if (Symbol.dispose) Serializer.prototype[Symbol.dispose] = Serializer.prototype.free;

export class Vec2 {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Vec2.prototype);
        obj.__wbg_ptr = ptr;
        Vec2Finalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        Vec2Finalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vec2_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get x() {
        const ret = wasm.__wbg_get_vec2_x(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set x(arg0) {
        wasm.__wbg_set_vec2_x(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get y() {
        const ret = wasm.__wbg_get_vec2_y(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set y(arg0) {
        wasm.__wbg_set_vec2_y(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) Vec2.prototype[Symbol.dispose] = Vec2.prototype.free;

/**
 * @param {number} level
 */
export function change_logging_level(level) {
    wasm.change_logging_level(level);
}

/**
 * @param {number} level
 */
export function enable_logging(level) {
    wasm.enable_logging(level);
}

const EXPECTED_RESPONSE_TYPES = new Set(['basic', 'cors', 'default']);

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && EXPECTED_RESPONSE_TYPES.has(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_Error_52673b7de5a0ca89 = function(arg0, arg1) {
        const ret = Error(getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_Number_2d1dcfcf4ec51736 = function(arg0) {
        const ret = Number(arg0);
        return ret;
    };
    imports.wbg.__wbg_String_8f0eb39a4a4c2f66 = function(arg0, arg1) {
        const ret = String(arg1);
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg___wbindgen_bigint_get_as_i64_6e32f5e6aff02e1d = function(arg0, arg1) {
        const v = arg1;
        const ret = typeof(v) === 'bigint' ? v : undefined;
        getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
    };
    imports.wbg.__wbg___wbindgen_boolean_get_dea25b33882b895b = function(arg0) {
        const v = arg0;
        const ret = typeof(v) === 'boolean' ? v : undefined;
        return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
    };
    imports.wbg.__wbg___wbindgen_debug_string_adfb662ae34724b6 = function(arg0, arg1) {
        const ret = debugString(arg1);
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg___wbindgen_in_0d3e1e8f0c669317 = function(arg0, arg1) {
        const ret = arg0 in arg1;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_bigint_0e1a2e3f55cfae27 = function(arg0) {
        const ret = typeof(arg0) === 'bigint';
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_function_8d400b8b1af978cd = function(arg0) {
        const ret = typeof(arg0) === 'function';
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_object_ce774f3490692386 = function(arg0) {
        const val = arg0;
        const ret = typeof(val) === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_string_704ef9c8fc131030 = function(arg0) {
        const ret = typeof(arg0) === 'string';
        return ret;
    };
    imports.wbg.__wbg___wbindgen_is_undefined_f6b95eab589e0269 = function(arg0) {
        const ret = arg0 === undefined;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_jsval_eq_b6101cc9cef1fe36 = function(arg0, arg1) {
        const ret = arg0 === arg1;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_jsval_loose_eq_766057600fdd1b0d = function(arg0, arg1) {
        const ret = arg0 == arg1;
        return ret;
    };
    imports.wbg.__wbg___wbindgen_number_get_9619185a74197f95 = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof(obj) === 'number' ? obj : undefined;
        getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
    };
    imports.wbg.__wbg___wbindgen_string_get_a2a31e16edf96e42 = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof(obj) === 'string' ? obj : undefined;
        var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg___wbindgen_throw_dd24417ed36fc46e = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_call_abb4ff46ce38be40 = function() { return handleError(function (arg0, arg1) {
        const ret = arg0.call(arg1);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_debug_5dd819dd7a95daa8 = function(arg0, arg1) {
        console.debug(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_done_62ea16af4ce34b24 = function(arg0) {
        const ret = arg0.done;
        return ret;
    };
    imports.wbg.__wbg_entries_83c79938054e065f = function(arg0) {
        const ret = Object.entries(arg0);
        return ret;
    };
    imports.wbg.__wbg_error_7534b8e9a36f1ab4 = function(arg0, arg1) {
        let deferred0_0;
        let deferred0_1;
        try {
            deferred0_0 = arg0;
            deferred0_1 = arg1;
            console.error(getStringFromWasm0(arg0, arg1));
        } finally {
            wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
        }
    };
    imports.wbg.__wbg_error_fdcd2fe555e2abe0 = function(arg0, arg1) {
        console.error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_file_1868ff27d18246de = function(arg0, arg1, arg2, arg3, arg4) {
        wasm_event_callback.file(arg0 >>> 0, getStringFromWasm0(arg1, arg2), arg3, arg4);
    };
    imports.wbg.__wbg_file_75cda19fcda8ea5a = function(arg0, arg1, arg2) {
        wasm_event_callback.file(arg0 >>> 0, getStringFromWasm0(arg1, arg2));
    };
    imports.wbg.__wbg_get_6b7bd52aca3f9671 = function(arg0, arg1) {
        const ret = arg0[arg1 >>> 0];
        return ret;
    };
    imports.wbg.__wbg_get_af9dab7e9603ea93 = function() { return handleError(function (arg0, arg1) {
        const ret = Reflect.get(arg0, arg1);
        return ret;
    }, arguments) };
    imports.wbg.__wbg_get_with_ref_key_1dc361bd10053bfe = function(arg0, arg1) {
        const ret = arg0[arg1];
        return ret;
    };
    imports.wbg.__wbg_instanceof_ArrayBuffer_f3320d2419cd0355 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof ArrayBuffer;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Map_084be8da74364158 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Map;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Uint8Array_da54ccc9d3e09434 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Uint8Array;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_interaction_03a13c59f708d601 = function(arg0, arg1, arg2) {
        wasm_event_callback.interaction(getStringFromWasm0(arg0, arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_interaction_a29c93328c826d6e = function(arg0, arg1, arg2) {
        wasm_event_callback.interaction(getStringFromWasm0(arg0, arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_interaction_be1cda85dfe0ec2c = function(arg0, arg1) {
        wasm_event_callback.interaction(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_isArray_51fd9e6422c0a395 = function(arg0) {
        const ret = Array.isArray(arg0);
        return ret;
    };
    imports.wbg.__wbg_isSafeInteger_ae7d3f054d55fa16 = function(arg0) {
        const ret = Number.isSafeInteger(arg0);
        return ret;
    };
    imports.wbg.__wbg_iterator_27b7c8b35ab3e86b = function() {
        const ret = Symbol.iterator;
        return ret;
    };
    imports.wbg.__wbg_length_22ac23eaec9d8053 = function(arg0) {
        const ret = arg0.length;
        return ret;
    };
    imports.wbg.__wbg_length_d45040a40c570362 = function(arg0) {
        const ret = arg0.length;
        return ret;
    };
    imports.wbg.__wbg_log_47870ad4a666878a = function(arg0, arg1) {
        console.log(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_new_1ba21ce319a06297 = function() {
        const ret = new Object();
        return ret;
    };
    imports.wbg.__wbg_new_6421f6084cc5bc5a = function(arg0) {
        const ret = new Uint8Array(arg0);
        return ret;
    };
    imports.wbg.__wbg_new_8a6f238a6ece86ea = function() {
        const ret = new Error();
        return ret;
    };
    imports.wbg.__wbg_new_b546ae120718850e = function() {
        const ret = new Map();
        return ret;
    };
    imports.wbg.__wbg_next_138a17bbf04e926c = function(arg0) {
        const ret = arg0.next;
        return ret;
    };
    imports.wbg.__wbg_next_3cfe5c0fe2a4cc53 = function() { return handleError(function (arg0) {
        const ret = arg0.next();
        return ret;
    }, arguments) };
    imports.wbg.__wbg_prototypesetcall_dfe9b766cdc1f1fd = function(arg0, arg1, arg2) {
        Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
    };
    imports.wbg.__wbg_set_3f1d0b984ed272ed = function(arg0, arg1, arg2) {
        arg0[arg1] = arg2;
    };
    imports.wbg.__wbg_set_efaaf145b9377369 = function(arg0, arg1, arg2) {
        const ret = arg0.set(arg1, arg2);
        return ret;
    };
    imports.wbg.__wbg_stack_0ed75d68575b0f3c = function(arg0, arg1) {
        const ret = arg1.stack;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
        getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    };
    imports.wbg.__wbg_value_57b7b035e117f7ee = function(arg0) {
        const ret = arg0.value;
        return ret;
    };
    imports.wbg.__wbg_warn_545f6d3e9811ef41 = function(arg0, arg1) {
        console.warn(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_cast_2241b6af4c4b2941 = function(arg0, arg1) {
        // Cast intrinsic for `Ref(String) -> Externref`.
        const ret = getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_cast_4625c577ab2ec9ee = function(arg0) {
        // Cast intrinsic for `U64 -> Externref`.
        const ret = BigInt.asUintN(64, arg0);
        return ret;
    };
    imports.wbg.__wbindgen_cast_9ae0607507abb057 = function(arg0) {
        // Cast intrinsic for `I64 -> Externref`.
        const ret = arg0;
        return ret;
    };
    imports.wbg.__wbindgen_cast_d6cd19b81560fd6e = function(arg0) {
        // Cast intrinsic for `F64 -> Externref`.
        const ret = arg0;
        return ret;
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = wasm.__wbindgen_externrefs;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
    };

    return imports;
}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedDataViewMemory0 = null;
    cachedUint32ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;


    wasm.__wbindgen_start();
    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (typeof module_or_path === 'undefined') {
        module_or_path = new URL('svelte_pixel_editor_wasm_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync };
export default __wbg_init;
